import { IKey } from "dto/IKey";
import { ItemKind } from "dto/IKindItems";

// Drukowanie przesyłek wychodzących — port Kwantum.Preview.ModalPrintManager z Magistratu.
// Mirror BE: Kwantum.LegalMail.Data/Printing/PrintSettingsDtos.cs + OutgoingParcel/OutgoingPrintDtos.cs.

/** Rodzaj wydruku generowanego na serwerze (= Kwantum.Enums.PrintFormatCategory z Magistratu). */
export enum EPrintFormatCategory {
  AddressSticker = 0,
  Envelope = 1,
  DispatchNote = 2,
}

/** Wzór zwrotki ZPO 160 × 101 mm. */
export enum EDispatchNoteDesign {
  Yellow = 0,
  White = 1,
}

/** Punkt odniesienia w osi (X: lewa / środek / prawa, Y: dół / środek / góra). */
export enum EPrintReference {
  LowerBound = 0,
  Center = 1,
  UpperBound = 2,
}

/** Kierunek przesunięcia (X: w prawo / w lewo, Y: w górę / w dół). */
export enum EPrintDirection {
  Ascending = 0,
  Descending = 1,
}

/** Obrót wydruku na papierze (stopnie jak w Magistracie). */
export enum EPrintRotation {
  None = 0,
  Positive = 90,
  Invert = 180,
  Negative = 270,
}

export interface IPrintFormat {
  Id: string;
  Category: EPrintFormatCategory;
  Name: string;
  WidthMm: number;
  HeightMm: number;
  IsDefault: boolean;
  SheetColumns?: number | null;
  SheetRows?: number | null;
  SheetMarginTopMm?: number | null;
  SheetMarginLeftMm?: number | null;
  SheetGapXMm?: number | null;
  SheetGapYMm?: number | null;
}

export interface IPrintProfile {
  Id: string;
  Name: string;
  ReferenceX: EPrintReference;
  ReferenceY: EPrintReference;
  DirectionX: EPrintDirection;
  DirectionY: EPrintDirection;
  OffsetXMm: number;
  OffsetYMm: number;
  Rotation: EPrintRotation;
}

export interface IPrintSettings {
  Formats: IPrintFormat[];
  Profiles: IPrintProfile[];
  CanEdit: boolean;
}

export type ISavePrintFormat = Omit<IPrintFormat, "Id"> & { Id?: string | null };
export type ISavePrintProfile = Omit<IPrintProfile, "Id"> & { Id?: string | null };

/** Źródło wydruku: przesyłki i/lub całe pisma (wszystkie przesyłki pisma). */
export interface IOutgoingPrintSource {
  ParcelIds?: string[];
  DocumentIds?: string[];
}

export interface IOutgoingPrintLetter {
  ParcelId?: string | null;
  DocumentId?: string | null;
  ParcelNumber?: string | null;
  ReceiverName?: string | null;
  Title?: string | null;
  Uri: string;
  FileName: string;
  /** null = plik jawny (kanały elektroniczne). */
  EncryptionKeyId?: string | null;
  Kind: ItemKind;
  /** false = dokument źródłowy (docx) — konwersja do PDF wtyczką. */
  IsPdf: boolean;
}

export interface IOutgoingPrintSources {
  Letters: IOutgoingPrintLetter[];
  Parcels: number;
  AddressStickers: number;
  Envelopes: number;
  DispatchNotes: number;
  Warnings: string[];
  SenderName?: string | null;
  SenderAddress?: string | null;
  ObjectKeys: IKey[];
  Keys: IKey[];
}

export interface IOutgoingPrintRenderRequest extends IOutgoingPrintSource {
  Category: EPrintFormatCategory;
  FormatId?: string | null;
  ProfileId?: string | null;
  PaperWidthMm?: number | null;
  PaperHeightMm?: number | null;
  PrintCaseSignature: boolean;
  PrintParcelSignature: boolean;
  PrintParcelTitle: boolean;
  PrintQrCode: boolean;
  FontSize?: number | null;
  Quantity?: number | null;
  Sheet?: boolean;
  Landscape?: boolean;
  Skip?: number | null;
  PrintSender?: boolean;
  Design?: EDispatchNoteDesign;
}
